import React, { Fragment, memo } from 'react';
import RGL, { WidthProvider } from 'react-grid-layout';
import _ from 'lodash';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Card, CardBody, CardTitle, Col } from 'reactstrap';

import moment from 'utils/moment';
import { renderInfoForType } from '../../../../utils/helpers';


import styles from './customTiles.module.scss';
import 'react-grid-layout/css/styles.css';

const ReactGridLayout = WidthProvider(RGL);

function CustomTiles({ data, layout }) {
    const generateDOM = () => _.map(layout, (tile) => {
      const rendered_tile = data.find(t => t?.id === parseInt(tile?.i, 10));
      const tileName = rendered_tile?.tile_name;
      let tileType = rendered_tile?.tile_type;
      let tileNoteData;
      if (tileType === 0) {
        tileType = 'Text';
        tileNoteData = rendered_tile?.tile_information;
      }
      if (tileType === 1) {
        tileType = 'Event';
        tileNoteData = (rendered_tile?.events)?.sort((a, b) => a.date?.localeCompare(b.date));
      }
      if (tileType === 4) {
        tileType = 'Link';
        tileNoteData = rendered_tile?.content_data;
      }
      if (tileType === 5) {
        tileType = 'Imagetext';
        tileNoteData = rendered_tile;
      }

      return (
          <div className={`${styles.card}`}
            data-grid={tile}
            key={tile?.i}
          >
            <div className={styles.relativeTable}>
              <div className={styles.cardContent}>
                  <div className={styles.tableData}>
                    {tileType === 'Text' && (
                      <>
                        <div
                          className={`${styles.tileName
                          }`}
                        >
                          {tileName}
                        </div>
                          <>
                            {tileNoteData
                            && (
                            <div className={styles.innerCard}>
                              <ReactQuill
                                className={styles.dataOfQuill}
                                value={tileNoteData}
                                readOnly
                                theme="bubble"
                              />
                            </div>
                            )
                            }
                          </>
                      </>
                    )}
                    {tileType === 'Event' && (
                      <>
                        <div
                          className={styles.tileName}
                        >
                          {tileName}
                        </div>
                        <Fragment>
                          <Col cols={12}>
                            {
                              tileNoteData?.length > 0
                              && tileNoteData.map(item => (
                                <Card className={styles.eventCard}>
                                  <CardTitle
                                    className={styles.cardTitle}
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}
                                  >
                                    <span>{item?.tile_name}</span>
                                  </CardTitle>
                                  <CardBody className="p-0">
                                    <div className={styles.dFlex}>
                                        <div className={styles.miniCard}>
                                          <div className={styles.flex}>
                                            <div>
                                              <div className={styles.eventDay}>
                                                <a href={`${item?.hyperlink}`} target="_blank" rel="noopener noreferrer">
                                                {moment(item?.date).format('D')}
                                                </a>
                                              </div>
                                              <div className={styles.eventMonth}>
                                                <a href={`${item?.hyperlink}`} target="_blank" rel="noopener noreferrer">
                                                  {moment(item?.date).format('MMM')}
                                                </a>
                                              </div>
                                              <div className={styles.eventYear}>
                                                <span>
                                                  {' '}
                                                  {renderInfoForType({ type: 'time' }, item?.time, null, null)}
                                                  {' '}
                                                </span>
                                              </div>
                                            </div>
                                            <div className={styles.content}>
                                              <div className={styles.eventName}>
                                                  {item?.name}
                                              </div>
                                              <div className={styles.eventDescription}>
                                                {item?.description}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              ))}
                          </Col>
                        </Fragment>
                      </>
                    )}

                    {tileType === 'Link' && (
                      <>
                        <div
                          className={`${styles.tileName
                          }`}
                        >
                          {tileName}
                        </div>
                        <Fragment>
                          <Col cols={12}>
                            { tileNoteData?.url?.length > 0
                              && tileNoteData?.url.map(item => (
                                <Card className={styles.linkCard}>
                                  <CardTitle
                                    className={styles.cardTitle}
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}
                                  >
                                    <span>{item?.tile_name}</span>
                                  </CardTitle>
                                  <CardBody className="p-0">
                                    <a href={`${item?.hyperlink}`} target="_blank" rel="noopener noreferrer">{item?.name}</a>
                                  </CardBody>
                                </Card>
                              ))}
                          </Col>
                        </Fragment>
                      </>
                    )}
                    {tileType === 'Imagetext' && (
                      <>
                          <div className={`${styles.tileName}`}>{tileName}</div>
                            {tileNoteData?.content_data?.imgText.length>0 && tileNoteData?.content_data?.imgText.map(eachTileImgText => (
                              <div style={{ display: 'flex', width: '100%' }}>
                                <div style={{ width: '40%' }}>
                                  <img className={styles.imagestyle} src={tileNoteData?.attachment[0]?.url} alt="" />
                                </div>
                                <div className={styles.textstyle} style={{ width: '50%', marginTop: '20px' }}>
                                  {eachTileImgText?.text}
                                </div>
                              </div>

                            ))
                            }
                      </>
                    )}
                  </div>
              </div>
            </div>
          </div>
      );
    });
  return <>
    <ReactGridLayout
      onLayoutChange={() => {}}
      draggableCancel="input, textarea"
      margin={[10, 10]}
      rowHeight={35}
      cols={4}
      isResizable={false}
      useCSSTransforms
      preventCollision={false}
      className={styles.customGrid}
    >
      {generateDOM()}
    </ReactGridLayout>
         </>;
}

export default memo(CustomTiles);
